import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import { Fragment } from 'react/jsx-runtime';
import OptionalComponent from '@ui/optional-component/optional-component';
import { StyleCategories } from '@/types/stylepacks.types';

interface Props {
  category: StyleCategories;
  setCategory: (cat: StyleCategories) => void;
}
export default function Nav({ category, setCategory }: Props) {
  return (
    <nav className="flex flex-column ai-flex-start">
      {Object.values(StyleCategories).map((styleCategory) => (
        <Fragment key={styleCategory}>
          <Button
            padding="10px 16px"
            width="100%"
            hoverBackgroundColor={category === styleCategory ? 'var(--gray-1100)' : 'rgba(var(--gray-1100-rgb), 0.5)'}
            backgroundColor={category === styleCategory ? 'var(--gray-1100)' : 'transparent'}
            onClick={() => setCategory(styleCategory)}
            className="L2 text-left"
          >
            {styleCategory}
          </Button>
          <OptionalComponent display={styleCategory === StyleCategories.recent}>
            <Text className="text-uppercase L3 margin-t-24 padding-l-16 padding-b-2" design="GlobalIcoText4">
              By Categories
            </Text>
          </OptionalComponent>
        </Fragment>
      ))}
    </nav>
  );
}
